import { DefaultMessages, ProgramThemeMessages, SegmentSpecificMessages } from '@sheerid/jslib';
import { RecursivePartial } from '../types/types';


type LibraryMessages = DefaultMessages & SegmentSpecificMessages & ProgramThemeMessages;

type ThisProjectMessages = {
    goToApp: string;
    goToAppButton: string;
    step: {
        pending: {
            redirectButtonTextPending: string,
            redirectUrl: string,
        },
        error: {
            redirectUrl: string;
        }
    },
};

export const messagesEN: RecursivePartial<LibraryMessages & ThisProjectMessages> = {
    emailAddress: 'School-issued email address',
    verifyMyTeacherStatus: 'VERIFY MY TEACHER STATUS',
    infoShared1: 'Information entered here will be used for verification purposes and shared with Sonic.',
    infoShared2: ' ',
    error: 'Error',
    goToApp: 'Please complete your verification in the SONIC App.',
    goToAppButton: 'Open SONIC App',
    step: {
        personalInfo: {
            title: 'Get exclusive teacher perks from SONIC!',
        },
        success: {
            title: "Success! You've been verified.",
            subtitle: 'Your account has been updated to reflect your teacher status.',
            emailNotification: ' ',
            verificationOnly: `
                SheerID handles verification only.
                Now that you've been approved, please direct all questions about the
                promotion terms to {companyName} customer service.
            `,
            redirectButtonText: 'CONTINUE TO YOUR ACCOUNT',
            redirectUrl: 'https://smart.link/5wjs8y6j719qx/',
        },
        docUpload: {
            title: 'We need more information',
            submitButtonLabel: 'SUBMIT',
            cancelButtonLabel: 'CANCEL',
            fileInstructions: 'DRAG AND DROP YOUR FILES HERE OR <span class="sid-dropzone-wrap--link">BROWSE</span>',
            uploadInstructions: 'Upload your school-issued document that shows:',
        },
        pending: {
            titleReview: 'Processing',
            subtitle: 'SheerID is reviewing your documents, to confirm your status. <br><br>This process may take up to {maxReviewTime}.',
            redirectButtonTextPending: 'CONTINUE TO SONIC',
            redirectUrl: 'https://smart.link/5wjs8y6j719qx/',
        },
        error: {
            redirectUrl: 'https://sonicdrivein.smart.link/27lmlmo47',
        },
    },
    errorId: {
        inactiveProgram: '<strong>The 2021 Class of the SONIC Teachers’ Circle is full.</strong><br><br>Stay tuned to SONIC emails for updates on the program.<br><br>You can still access exclusive deals in the SONIC App including half price drinks and slushes any time!',
    },
};
